import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";
import React from "react";
import { FieldDefinition } from ".";
import FieldForm, { defaultfieldModel } from "./FieldForm";

interface Props {
  show: boolean;
  onCancel(): void;
  submit(definition: FieldDefinition): void;
}

export default function CreateFieldModal(props: Props) {
  const [field, setField] = React.useState<FieldDefinition>(defaultfieldModel);

  return (
    <Modal show={props.show}>
      <ModalHeader title="Add Field" onClose={() => props.onCancel()} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.submit(field);
          setField(defaultfieldModel);
        }}
      >
        <ModalBody>
          <div className="p-4">
            <FieldForm
              field={field}
              onChange={(updates) => {
                setField((oldState) => ({ ...oldState, ...updates }));
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="flex p-4">
            <div className="ml-auto flex flex-row">
              <div className="mr-2">
                <SecondaryBlueButton
                  label="Cancel"
                  onClick={props.onCancel}
                />
              </div>
              <PrimaryBlueButton
                label="Add Field"
                disabled={!field.label.trim()}
                onClick={() => {
                  props.submit(field);
                  setField(defaultfieldModel);
                }}
              />
            </div>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}
